export default {"src":"/_next/static/media/right-caret.6b6ce6c8.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};